// Test id przycisków współdzielonych między widokami RP. Jeden klucz oznacza wspólną funkcję kontrolki, a nie jeden element w całym DOM: ten sam przycisk może występować w kilku kontekstach jednocześnie (np. listing i modal oferty).

export const BUTTONS_TEST_ID = {
    // Element otwierający panel filtrów (drawer na desktopie, modal „Filtry” na mobile). Stoi na klikalnym elemencie, nie na ikonie.
    OPEN_FILTERS_BUTTON: "filters-open-button"
};
// Test id przycisków współdzielonych między widokami RP. Jeden klucz oznacza wspólną funkcję kontrolki, a nie jeden element w całym DOM: ten sam przycisk może występować w kilku kontekstach jednocześnie (np. listing i modal oferty).

export const BUTTONS_TEST_ID = {
    // Element otwierający panel filtrów (drawer na desktopie, modal „Filtry” na mobile). Stoi na klikalnym elemencie, nie na ikonie.
    OPEN_FILTERS_BUTTON: "filters-open-button"
};
